module.exports = __webpack_public_path__ + "static/zinc-logo-fc51bf1c8963f84cc27a3e568dc2ebbe.png";